import { GAMES_META, IMAGES } from "../../data/site";
import { useSite } from "../../context/SiteContext";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../i18n/LangContext";
import { SectionHead } from "./Brand";

export const Games = ({ onJoin }) => {
  const { games: t } = useLang().t;
  const games = t.items.map((g, i) => ({ ...g, ...(GAMES_META[i] || { image: "casino", span: "" }), src: g.image }));
  const { site } = useSite();
  return (
  <section id="games" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
    <SectionHead eyebrow={t.eyebrow} title={t.title} sub={t.sub} />
    <div className="grid auto-rows-[260px] grid-cols-1 gap-5 md:grid-cols-4">
      {games.map((g, i) => (
        <button key={i} onClick={onJoin} data-testid={`game-card-${i}`}
          className={`group relative overflow-hidden rounded-2xl border border-[#D4AF37]/25 text-left transition-colors hover:border-[#D4AF37] ${g.span}`}>
          <img src={g.src ? fileUrl(g.src, site?.performance?.cdn_base_url) : IMAGES[g.image]} alt={g.title} loading={site?.performance?.lazyload !== false ? "lazy" : "eager"} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
          <div className="relative flex h-full flex-col justify-end p-6">
            <h3 className="font-serif text-xl font-semibold text-[#D4AF37] sm:text-2xl">{g.title}</h3>
            <p className="mt-2 max-w-md text-sm text-zinc-300">{g.desc}</p>
            <span className="gold-underline mt-4 w-fit text-xs uppercase tracking-widest text-white">{t.play}</span>
          </div>
        </button>
      ))}
    </div>
  </section>
  );
};
